"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseWorkflowLayout = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var header_1 = require("./components/header");
var GrayPageBG = (0, styled_components_1.createGlobalStyle)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    margin: 0;\n    padding: 0 !important;\n    background-color: ", ";\n  }\n"], ["\n  body {\n    margin: 0;\n    padding: 0 !important;\n    background-color: ", ";\n  }\n"])), core_ui_1.colors.steel[50]);
function BaseWorkflowLayout(_a) {
    var children = _a.children, title = _a.title, backTooltipText = _a.backTooltipText, onBack = _a.onBack;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GrayPageBG, null),
        react_1.default.createElement(Container, null,
            react_1.default.createElement(header_1.WorkflowHeader, { title: title, backTooltipText: backTooltipText, onBack: onBack }),
            react_1.default.createElement(PageContent, null, children))));
}
exports.BaseWorkflowLayout = BaseWorkflowLayout;
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  height: 100vh;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  height: 100vh;\n"])));
var PageContent = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n"], ["\n  flex: 1;\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
